import React, { useCallback } from "react";
import { IndicatorContent } from "@/components/Calendars/Common";
import IconFont from "@/components/icon";
import { message } from "antd";
import { isFocusEnv } from "@/utils";
import { getAvsdk, WEB_SDK_LIST } from "@/baseComponents/Meeting/utils";
import { MeetingPlatform } from "@/types/common";
import BaseButton from "@/components/Calendars/Button";
import style from "./index.module.less";
import { useTranslation } from "react-i18next";
import { joinMeetingOperation, joinLiveOperation } from "@/components/Calendars/utils/operation";
import { useThrottle } from "@/utils/chat/index";
import { getScheduleMeetingInfo, IMeetingModal } from "@/api/calendar";
import { queryLiveInfo } from "@/api/meeting";
import CopyClipboard from "copy-to-clipboard";
import { AVSDK } from "@/baseComponents/Meeting/common";

export function MeetingComp({
  meetingInfo,
  clickCb,
  authInfo,
  newPublicResult,
  history,
  currentPlay
}: {
  meetingInfo: IMeetingModal;
  clickCb?: Function;
  authInfo: any;
  newPublicResult: boolean;
  history: any;
  currentPlay?: any;
}) {
  const { t } = useTranslation("calendar");

  const handleCopy = useCallback(() => {
    const onMeetingInfo = {
      meetingId: meetingInfo.meetingUuid || "", // 会议uuid
      meetingCode: meetingInfo.meetingId || "", // 会议号
      platform: meetingInfo.meetingPlatform || "" // 会议平台
    };
    getScheduleMeetingInfo(onMeetingInfo || {})
      .then((res: any) => {
        if (!res) {
          return message.error("复制失败");
        }
        const live = res.liveId ? `直播间号：${res.liveId}\n直播间密码：${res.livePwd}` : "";

        const copyText = `会议类型：${meetingInfo.meetingPlatformName || ""}\n会议主题：${
          res.topic
        } \n\n会议链接： \n点击链接直接加入会议： \n${
          res.meetingShortUrl
        }\n**PC端推荐使用Chrome浏览器**\n\n主持人：${res.organizerName}\n会议号：${
          res.meetingCode
        }\n${live}`;

        if (CopyClipboard(copyText)) {
          message.success("复制成功");
        } else {
          message.error("复制失败");
        }
      })
      .catch((err) => {
        return message.error((err.message || err || "复制失败").toString());
      });
  }, [meetingInfo]);

  const handleJoinMeeting = useThrottle(() => {
    if (!meetingInfo) {
      return;
    }
    if (currentPlay) {
      history.push({
        pathname: "/meeting",
        state: {
          avsdk: getAvsdk(meetingInfo.meetingPlatform as MeetingPlatform),
          meetingNumber: meetingInfo.meetingId,
          meetingPassword: meetingInfo.password,
          meetingTopic: meetingInfo.title,
          isvideooff: true,
          isaudiooff: true
        }
      });
      return;
    }
    joinMeetingOperation(authInfo, meetingInfo, newPublicResult, () => {
      clickCb?.();
    });
  }, 2000);
  const handleJoinLive = useThrottle(() => {
    if (!meetingInfo) {
      return;
    }
    const liveCode = meetingInfo.liveInfo?.liveId;
    if (!liveCode) {
      return;
    }
    if (currentPlay) {
      queryLiveInfo({
        liveCode: meetingInfo.liveInfo?.liveId || "",
        livePassword: meetingInfo.liveInfo?.password || ""
      }).then(([res, err]) => {
        if (!res || err) {
          message.error(err || "获取直播信息失败");
          return;
        }
        const bizId = `${res.meetingCode}_${liveCode}`;
        const gid = `live-${bizId}`;
        history.push({
          pathname: "live",
          search: `?avsdk=jbrtc&type=live&gid=${gid}`,
          state: {
            liveCode,
            meetingCode: res.meetingCode,
            meetingId: res.meetingId,
            liveUrl: res.liveUrl,
            conferenceTitle: res.conferenceTitle
          }
        });
      });
      return;
    }
    joinLiveOperation(meetingInfo, history, () => {
      clickCb?.();
    });
  }, 2000);
  if (!meetingInfo) {
    return null;
  }
  return (
    <>
      <IndicatorContent
        className="metting-title"
        indicator={() => (
          <div className="calendar-tooltip-content-label">{t("online metting")}</div>
        )}
      >
        {meetingInfo.meetingPlatformName && (
          <p className={`info info-important ${style["name"]}`}>
            {meetingInfo.meetingPlatformName}
          </p>
        )}
        <div className={`${style["copy-info"]}`} onClick={handleCopy}>
          <IconFont type="iconic_pc_calender_copy" /> 复制会议信息
        </div>
      </IndicatorContent>
      <IndicatorContent>
        <div className={`${style["info-bg-metting"]}`}>
          <p>
            {t("meeting_id")}：
            <span style={{ display: "inline-block" }}>
              {meetingInfo.meetingId}
              {/* <IconFont
                className="copy-icon"
                type="iconic_pc_calender_copy"
                onClick={() => {
                  const input = document.createElement("input");
                  document.body.appendChild(input);
                  input.setAttribute("value", meetingInfo.meetingId);
                  input.select();
                  if (document.execCommand("copy")) {
                    document.execCommand("copy");
                    message.success("复制成功");
                  }
                  document.body.removeChild(input);
                }}
              /> */}
            </span>
          </p>
          <p>
            {t("calendar password")}：
            {meetingInfo.password && (
              <span style={{ display: "inline-block" }}>
                {meetingInfo.password}{" "}
                {/* <IconFont
                  className="copy-icon"
                  type="iconic_pc_calender_copy"
                  onClick={() => {
                    const input = document.createElement("input");
                    document.body.appendChild(input);
                    input.setAttribute("value", meetingInfo.password);
                    input.select();
                    if (document.execCommand("copy")) {
                      document.execCommand("copy");
                      message.success("复制成功");
                    }
                    document.body.removeChild(input);
                  }}
                /> */}
              </span>
            )}
            {!meetingInfo.password && (
              <span
                style={{
                  display: "inline-block",
                  color: "#8f959e",
                  marginLeft: "2px"
                }}
              >
                {t("no_password")}
              </span>
            )}
          </p>
          {(isFocusEnv() ||
            WEB_SDK_LIST.includes(
              getAvsdk(meetingInfo.meetingPlatform as MeetingPlatform) as AVSDK
            )) && (
            <BaseButton
              clstag="pageclick|keycount|xtbg_Pcschdule|JoininNow"
              className={style["button-join-meeting"]}
              onClick={handleJoinMeeting}
              size="small"
            >
              {t("joinMeeting")}
            </BaseButton>
          )}
        </div>
      </IndicatorContent>
      {meetingInfo?.liveInfo?.liveId && (
        <IndicatorContent>
          <div className={`${style["info-bg-metting"]} ${style["info-bg-live"]}`}>
            <div>
              <div className={style["detail"]}>
                <p>
                  {t("liveCode")}：
                  <span style={{ display: "inline-block" }}>
                    {meetingInfo?.liveInfo?.liveId}
                    {/* <IconFont
                      className="copy-icon"
                      type="iconic_pc_calender_copy"
                      onClick={() => {
                        const input = document.createElement("input");
                        document.body.appendChild(input);
                        input.setAttribute("value", meetingInfo?.liveInfo?.liveId as string);
                        input.select();
                        if (document.execCommand("copy")) {
                          document.execCommand("copy");
                          message.success("复制成功");
                        }
                        document.body.removeChild(input);
                      }}
                    /> */}
                  </span>
                </p>
                <p>
                  {t("password")}：
                  {meetingInfo.liveInfo?.password && (
                    <span style={{ display: "inline-block" }}>
                      {meetingInfo.liveInfo?.password}{" "}
                      {/* <IconFont
                        className="copy-icon"
                        type="iconic_pc_calender_copy"
                        onClick={() => {
                          const input = document.createElement("input");
                          document.body.appendChild(input);
                          input.setAttribute("value", meetingInfo.liveInfo?.password as string);
                          input.select();
                          if (document.execCommand("copy")) {
                            document.execCommand("copy");
                            message.success("复制成功");
                          }
                          document.body.removeChild(input);
                        }}
                      /> */}
                    </span>
                  )}
                  {!meetingInfo.liveInfo?.password && (
                    <span
                      style={{
                        display: "inline-block",
                        color: "#8f959e",
                        marginLeft: "2px"
                      }}
                    >
                      {t("no_password")}
                    </span>
                  )}
                </p>
              </div>
              <div className={style["live-limit"]}>
                <p>
                  {meetingInfo.liveInfo.maxPeopleCount
                    ? `直播观看人数上限为${meetingInfo.liveInfo.maxPeopleCount}，`
                    : ""}
                  仅支持互联网观看
                </p>
              </div>
            </div>
            <BaseButton
              clstag="pageclick|keycount|xtbg_Pcschdule|JoininNow"
              className={style["button-join-live"]}
              onClick={handleJoinLive}
              size="small"
            >
              {t("joinLive")}
            </BaseButton>
          </div>
        </IndicatorContent>
      )}
    </>
  );
}
